export default __webpack_public_path__ + "static/media/cpp.10675888.svg";